<template>
    <van-popup v-model="showCcRequest"  round position="bottom" :style="{ height: '80%' }">
        <div class="cc_show">

            <!-- tab栏选择 -->
            <van-tabs color="#1989FA" type="line" v-model="tabActive">
                <van-tab name="0" title="部门" style="height: 80%;" v-if="deptList.length > 0">
                </van-tab>
                <van-tab name="1" title="老师" v-if="teacherList.length > 0">
                </van-tab>
            </van-tabs>
            <!-- 最近请假人数 -->

            <div class="recently" v-if="tabActive == 0 && deptList.length > 0">
                <div class="colleague_person_list">
                    <div class="list_con_con">
                        <div class="list_con" v-for="dept in deptList">
                            <img :src="schoolIcon" />
                            <div class="person_info">
                                <span class="name">
                                    {{ dept.name }}
                                </span>
                                <span class="deptname">
                                    {{ dept.remark }} 人
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="change_list_text" @click="close">关闭</div>
            </div>

            <!-- 同事/老师选择 -->
            <div class="colleague" v-if="tabActive == 1 && teacherList.length > 0">
                <!-- 搜索框 -->
                <div class="colleague_person_list">
                    <div class="list_con_con">
                        <div class="list_con" v-for="item in teacherList">
                            <img :src="item.avatar" />
                            <div class="person_info">
                                <span class="name">
                                    {{ item.name }}
                                </span>
                                <span class="deptname">
                                    {{ item.remark }}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="change_list_text" @click="close">关闭</div>
            </div>
        </div>
    </van-popup>
</template>
<script>
export default {
    props: ['leaveType', 'personType','deptList','teacherList'],
    data() {
        return {
            // 弹窗显示隐藏
            showCcRequest: false,
            // 默认展示的tab栏序号
            tabActive:'0',
            // 部门背景图
            schoolIcon: require('@/assets/school_icon.png'),
            // 搜索的人员姓名
        }
    },

    mounted () {

    },
    methods: {
        close() {
            this.showCcRequest = false
        }
    }
}
</script>
<style lang="scss" scoped>
.cc_show {
    height: 100%;
    display: flex;
    flex-direction: column;


    .recently {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;

        .colleague_person_list {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            position: relative;

            .list_con_con {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

                .list_con {
                    padding: 0 1.1111rem;
                    display: flex;
                    align-items: center;

                    img {
                        width: 2.8462rem;
                        height: 2.8462rem;
                        border-radius: 50%;
                        margin-left: 12px;
                    }

                    .person_info {
                        display: flex;
                        // height: 3.8462rem;
                        flex: 1;
                        border-bottom: 1px solid #E5E5E5;
                        padding: .8rem 0;
                        margin-left: 1.1rem;
                        flex-direction: column;

                        .name {
                            font-size: 16px;
                            color: #191919;
                            margin-bottom: 5px;
                        }

                        .deptname {
                            font-size: 12px;
                            color: #A0A0A0;
                        }
                    }
                }
            }

        }

        .change_list_text {
            background-color: #A0A0A0;
            color: #fff;
            // display: flex;
            height: 3rem;
            line-height: 3rem;
            margin: 10px 20px 10px;
            border-radius: 1.5rem;
            text-align: center;

            .number_span {
                flex: 1;
                text-align: left;
            }
        }
    }

    // 同事
    .colleague {
        display: flex;
        flex: 1;
        // background-color: pink;
        flex-direction: column;
        justify-content: space-between;

        .colleague_search {
            border-top: 1px solid #E5E5E5;
            border-bottom: 1px solid #E5E5E5;
            height: 3.3rem;

            .search_btn {
                width: 3rem;
                text-align: center;
            }
        }

        .colleague_person_list {
            flex: 1;
            display: flex;
            position: relative;
            flex-direction: column;
            overflow-y: auto;

            .list_con_con {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            .list_con {
                padding: 0 1.1111rem;
                display: flex;
                align-items: center;

                img {
                    width: 2.8462rem;
                    height: 2.8462rem;
                    border-radius: 50%;
                    margin-left: 12px;
                }

                .person_info {
                    display: flex;
                    // height: 3.8462rem;
                    flex: 1;
                    border-bottom: 1px solid #E5E5E5;
                    padding: .8rem 0;
                    margin-left: 1.1rem;
                    flex-direction: column;

                    .name {
                        font-size: 16px;
                        color: #191919;
                        margin-bottom: 5px;
                    }

                    .deptname {
                        font-size: 12px;
                        color: #A0A0A0;
                    }
                }
            }
        }

        .change_list_text {
            background-color: #A0A0A0;
            color: #fff;
            // display: flex;
            height: 3rem;
            line-height: 3rem;
            margin: 10px 20px 10px;
            border-radius: 1.5rem;
            text-align: center;

            .number_span {
                flex: 1;
                text-align: left;
            }
        }
    }

    //部门
    .department {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;

        .colleague_person_list {
            flex: 1;
            display: flex;
            position: relative;
            flex-direction: column;
            overflow-y: auto;

            .list_con_con {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

                .van-collapse {
                    .van-collapse-item {
                        .van-cell {
                            align-items: center !important;
                            padding: 0 1rem;
                        }

                        .van-collapse-item__wrapper {
                            .van-collapse-item__content {
                                padding: 0 1rem;
                            }
                        }
                    }

                }

                .list_con {
                    display: flex;
                    align-items: center;

                    img {
                        width: 2.8462rem;
                        height: 2.8462rem;
                        border-radius: 50%;
                        margin-left: 12px;
                    }

                    .person_info {
                        display: flex;
                        // height: 3.8462rem;
                        flex: 1;
                        // border-bottom: 1px solid #E5E5E5;
                        padding: .8rem 0;
                        margin-left: 1.1rem;
                        flex-direction: column;

                        .name {
                            font-size: 16px;
                            color: #191919;
                        }

                        .deptname {
                            font-size: 12px;
                            color: #A0A0A0;
                        }
                    }
                }
            }

        }

        .change_list_text {
            background-color: #A0A0A0;
            color: #fff;
            // display: flex;
            height: 3rem;
            line-height: 3rem;
            margin: 10px 20px 10px;
            border-radius: 1.5rem;
            text-align: center;

            .number_span {
                flex: 1;
                text-align: left;
            }
        }
    }
}

// 最近
</style>